export class Event {

  id: string | undefined;
  deliveryDateTime: string | undefined;
  lastFailedDateTime: string | undefined;
  nextSendAttemptNotBefore: string | undefined;
  entityId: string | undefined;
  entityExternalId: string | undefined;
  eventType: string | undefined;
  deliveryAttempt: number;
  state: string | undefined;
  lastResponseCode: number
  lastResponseBody: string | undefined;
  subscription: EventSubscription
  eventDatetime: string | undefined;
  data: any
  generatedWebHookJson: any

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.deliveryDateTime = payload.deliveryDateTime;
      this.lastFailedDateTime = payload.lastFailedDateTime;
      this.nextSendAttemptNotBefore = payload.nextSendAttemptNotBefore;
      this.entityId = payload.entityId;
      this.entityExternalId = payload.entityExternalId;
      this.eventType = payload.eventType;
      this.deliveryAttempt = payload.deliveryAttempt;
      this.state = payload.state;
      this.lastResponseCode = payload.lastResponseCode;
      this.lastResponseBody = payload.lastResponseBody;
      if(payload.subscription){
        this.subscription = new EventSubscription(payload.subscription);
      }
      this.eventDatetime = payload.eventDatetime;
      this.data = payload.data;
      this.generatedWebHookJson = payload.generatedWebHookJson;
    }
  }

  /**
   * creates roles from a result
   * @param result Array of any
   * @returns Array of ApiKey
   */
   static createEvents(result: Array<any>): Event[] {
    const events = new Array<Event>();
    if (result) {
      result.map((event) => {
        events.push(new Event(event));
      });
    }
    return events;
  }
}


export class EventSubscription {
  id: string | undefined;
  externalId: string | undefined;
  url: string | undefined;
  eventTypes: [string] | undefined;;
  lastTriggeredDateTime: string | undefined;
  active: boolean | undefined;
  type: string | undefined;
  customHtmlHeaders: any | undefined;
  customHeadersArray: Array<{ name: string, value: string }>;
  secretHash: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.url = payload.url;
      this.eventTypes = payload.eventTypes;
      this.lastTriggeredDateTime = payload.lastTriggeredDateTime;
      this.active = payload.active;
      this.type = payload.type;
      this.customHtmlHeaders = payload.customHtmlHeaders;
      if(this.customHtmlHeaders) {
        this.customHeadersArray = this.convertObjectToArray(this.customHtmlHeaders);
      }
      
      this.secretHash = payload.secretHash;
    }
  }
  
  /**
   * creates roles from a result
   * @param result Array of any
   * @returns Array of ApiKey
   */
   static createEventSubscription(result: Array<any>): EventSubscription[] {
    const eventSubscriptions = new Array<EventSubscription>();
    if (result) {
      result.map((event) => {
        eventSubscriptions.push(new EventSubscription(event));
      });
    }
    return eventSubscriptions;
  }

  convertObjectToArray(obj: any): Array<{ name: string, value: string }> {
    console.log('convertObjectToArray', obj);
    const result: Array<{ name: string, value: string }> = [];
    if (obj) {
      Object.keys(obj).forEach(key => {
        result.push({ name: key, value: obj[key] });
      });
    }
    return result;
  }
}

export class EventSubscriptionInput {
  id: string | undefined;
  externalId: string | undefined;
  url: string | undefined;
  eventTypes: [string] | undefined;;
  active: boolean | undefined;
  type: string | undefined;
  customHtmlHeaders: any | undefined;
  secret: string | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.url = payload.url;
      this.eventTypes = payload.eventTypes;
      this.active = payload.active;
      this.type = payload.type;
      this.customHtmlHeaders = payload.customHtmlHeaders;
      this.secret = payload.secret;
    }
  }

}